import ClickTracking from '@/share/campaign/click-tracking-mixin'

export default {
  mixins: [ClickTracking],

  props: {
    sharingOptions: {
      type: Object,
      required: true
    }
  },

  computed: {
    channelNameForAnalytics() {
      return 'Messenger'
    }
  },

  methods: {
    handleClick() {
      const shareClickToken = this.trackEvent()
      const url = this.urlWithShareClickTokenInInnerUrl(this.sharingOptions.href, shareClickToken, 'link')
      window.open(url)
    }
  }
}
